// c:/xampp/htdocs/miners-market-main/components/forms/OreSaleForm.js

import AccordionSection from '../AccordionSection.jsx';
import MediaManager from './MediaManager.jsx';

function OreSaleForm({ formData, onFormChange, openSection, onToggleSection }) {
    // Assuming AccordionSection and ImageUploadSection are globally available or imported
    return (
        <div className="space-y-2">
            <AccordionSection title="1. Ore Details" id="oreDetails" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Listing Title*</label>
                        <input type="text" name="name" value={formData.name || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., High-Grade Iron Ore" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Price per Ton (R)*</label>
                        <input type="text" name="price" value={formData.price ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Grade (%)</label>
                        <input type="text" name="ore_grade" value={formData.ore_grade || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., 62%" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Quantity Available (Tons)</label>
                        <input type="text" name="quantity_available" value={formData.quantity_available ?? ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., 10,000" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Location of Ore*</label>
                    <input type="text" name="location" value={formData.location || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div>
            </AccordionSection>

            <AccordionSection title="2. Images" id="images" openSection={openSection} onToggle={onToggleSection}>
                <MediaManager formData={formData} onFormChange={onFormChange} />
            </AccordionSection>

            <AccordionSection title="3. Contact Information" id="contact" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Name</label>
                        <input type="text" name="sales_contact_name" value={formData.sales_contact_name || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Phone</label>
                        <input type="tel" name="sales_contact_phone" value={formData.sales_contact_phone || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Email</label>
                        <input type="email" name="sales_contact_email" value={formData.sales_contact_email || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Company Name & Address</label>
                        <input type="text" name="company_name_address" value={formData.company_name_address || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
            </AccordionSection>
        </div>
    );
}

export default OreSaleForm;
